import * as React from "react";
import EventListener, { withOptions } from "react-event-listener";
import { List as MaterialList, ListItem } from "material-ui";
import IconButton from "material-ui/IconButton";
import ClearIcon from "material-ui/svg-icons/content/clear";
import { BaseComponent } from "components/BaseComponent/BaseComponent";
import { throttle } from "lodash";
import styles = require("./style.less");
import BorderedListItem from "components/BorderedListItem";

interface RemoveItemsListProps<R> {
    empty?: React.ReactNode;
    data: R[];
    clearButtonToolTip?: string;
    listActions?: JSX.Element[];
    onRow(item: R, idx: number): React.ReactNode;
    onRowTouch?(item: R): void;
    onRemoveRow?(item: R): void;
}

export abstract class RemoveItemsList<R> extends BaseComponent<RemoveItemsListProps<R>, any> {
    private topActionsMenu: any;
    private bottomActionsMenu: any;
    private handleResize: any;
    private handleScroll: any;

    constructor(props: RemoveItemsListProps<R>) {
        super(props);

        this.updateButtonsVisibility = this.updateButtonsVisibility.bind(this);
        this.handleResize = throttle(this.updateButtonsVisibility, 100);
        this.handleScroll = throttle(this.updateButtonsVisibility, 50);
    }

    componentDidMount() {
        this.updateButtonsVisibility();
    }

    componentWillUnmount() {
        this.handleResize.cancel();
        this.handleScroll.cancel();
    }

    render() {
        const actions = (this.props.listActions || []).map((action, index) => React.cloneElement(action, { key: index }));

        return (
            <div>
                <EventListener
                    target="window"
                    onResize={this.handleResize}
                    onScroll={withOptions(this.handleScroll, { passive: true, capture: false })}
                />
                <div ref={el => this.topActionsMenu = el} className={styles.actionsMenu}>{actions}</div>
                {this.props.data.length === 0 && <div className={styles.emptyList}>{this.props.empty}</div>}
                {this.props.data.length !== 0 && <MaterialList>
                    {this.props.data.map((item, index) => this.buildItem(item, index))}
                </MaterialList>}
                <div ref={el => this.bottomActionsMenu = el} style={{ visibility: "hidden" }} className={styles.actionsMenu}>{actions}</div>
            </div>
        );
    }

    private updateButtonsVisibility() {
        if (this.topActionsMenu && this.bottomActionsMenu) {
            let result = "visible";

            if (this.isElementInViewport(this.topActionsMenu)) {
                result = "hidden";
            } else if (!this.isElementInViewport(this.bottomActionsMenu)) { //if neither are visible it might be that we're in a tab that isn't showing,
                result = "hidden";                                       //so hide the bottom one so we don't show both when we come back
            }

            this.bottomActionsMenu.style.visibility = result;
        }
    }

    private isElementInViewport(el: any) {
        const rect = el.getBoundingClientRect();
        const vWidth = window.innerWidth || document.documentElement.clientWidth;
        const vHeight = window.innerHeight || document.documentElement.clientHeight;

        // Return false if it's not in the viewport
        if (rect.right < 0 ||
            rect.bottom < 0 ||
            rect.left > vWidth ||
            rect.top > vHeight) {
            return false;
        }

        return el.contains(document.elementFromPoint(rect.right - (rect.width / 2), rect.bottom - (rect.height / 2)));
    }

    private buildItem(item: R, index: number) {
        const clearButton = this.props.onRemoveRow ? <IconButton
            tooltip={this.props.clearButtonToolTip}
            onClick={e => {
                e.stopPropagation();
                this.props.onRemoveRow(item);
            }}>
            <ClearIcon />
        </IconButton> : null;

        return <BorderedListItem key={(item as any).Id || index} rightIconButton={clearButton}
            onClick={this.props.onRowTouch ? (e: any) => this.onTouch(item) : null}
            disabled={this.props.onRowTouch ? false : true}>
            {this.props.onRow(item, index)}
        </BorderedListItem>;
    }

    private onTouch(item: R) {
        if (this.props.onRowTouch) {
            this.props.onRowTouch(item);
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/RemoveItemsList/RemoveItemsList.tsx